import { createFileRoute } from "@tanstack/react-router";
import InvestorRecipients from "@/components/InvestorRecipients";

function RouteComponent() {
  return <InvestorRecipients />;
}

export const Route = createFileRoute("/_authenticated/investor-recipients/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
